import { CommentPlacement, CommentType } from '@distribute/shared/types';
import { JSONContent } from '@tiptap/react';

export enum CommentsFlow {
  Preview = 'preview',
  Create = 'create',
}

export type NodeSelection = {
  from: number;
  to: number;
  selectionType: 'block' | 'inline';
  position: DOMRect;
};

export type StartCommentAction = NodeSelection;

export type CreateCommentThreadAction = {
  pageId: string;
  contentItemId?: number;
  target: CommentPlacement;
  type?: CommentType;
  contentJson: JSONContent;
};

export type UpdateThreadStatusAction = {
  threadId: string;
  resolved: boolean;
};

export type UpdateCommentContent = {
  threadId: string;
  commentId: string;
  content: JSONContent;
  cb?: (err?: unknown) => void;
};

export type DeleteThreadAction = {
  threadId: string;
};
export type DeleteCommentAction = {
  threadId: string;
  commentId: string;
};

export type StartCommentingFlowAction = {
  onCreate: (threadId: string) => void;
  onError: (error: unknown) => void;
  onCancel: () => void;
};

export type MarkThreadAsDeletedAction = {
  threadId: string;
  markedAsDeleted: boolean;
};

export type CreateCommentReplyAction = {
  threadId: string;
  content: JSONContent;
  cb?: (err?: unknown) => void;
};
